import axios from "axios";
import { useState } from "react";
import Modal from "react-modal";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL


export function StationConfirmationModal({
  stationId,
  state,
  rerender,
  setRerender
}) {
  const [stationModalOpen, setStationModalOpen] = useState(false);

  function deleteStation(stationId) {
    axios.delete(`${API_URL}/training/delete-station-by-id`, {
      headers: {
        'token': localStorage.getItem("token")
      },
      params: {
        sessionId: state.session,
        stationId: stationId
      }
    }).then(response => {
      // TODO Send confirmation to user
      setRerender(!rerender);
    }).catch(error => {});
  }

  function confirmDeleteStation(stationId) {
    deleteStation(stationId);
    setStationModalOpen(false);
  }

  return <div>
            <button className="inline-block rounded-full border border-red-200 bg-white px-3 py-2 text-sm font-semibold text-red-700 shadow-sm transition-colors hover:bg-red-50" onClick={() => {
      setStationModalOpen(true);
    }}>Ta bort</button>
            <Modal className="fixed w-full h-full flex items-center justify-center" isOpen={stationModalOpen} ariaHideApp={false} onRequestClose={() => setStationModalOpen(false)}>
                <div className="max-w-sm rounded-[28px] bg-white p-5 shadow-lg ring-1 ring-slate-200">
                    <p className="text-center text-xl font-semibold text-slate-800">Radera station</p>
                    <p className="p-4 text-center text-sm text-slate-600">Är du säker på att du vill radera stationen?</p>
                    <div className="flex justify-between p-4">
                        <button className="inline-block rounded-[18px] border border-red-200 bg-gradient-to-r from-red-500 to-rose-500 px-4 py-3 text-sm font-semibold text-white shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md" onClick={() => confirmDeleteStation(stationId)}>Fortsätt</button>
                        <button className="inline-block rounded-[18px] border border-slate-200 bg-slate-100 px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:bg-slate-200" onClick={() => setStationModalOpen(false)}>Avbryt</button>
                    </div>
                </div>
            </Modal>
        </div>;
}
  
